<h3 class="title">{{ _text.title }}</h3>

<app-input-control
    [autofocus]="true"
    [control]="control_subject"
    [label]="_text.subject_label"
    [required]="true"
/>

<app-chips-control
    (chipRemove)="emit_chipRemove($event)"
    [emptyText]="_text.participants_empty"
    [items]="chips$$()"
    [label]="_text.participants_label"
    [removable]="true"
    [removeTooltip]="_text.remove"
/>

<app-autocomplete-control
    (optionSelected)="emit_optionSelected($event)"
    [clearOnSelect]="true"
    [control]="control_search"
    [fieldName_display]="optionField.display"
    [fieldName_value]="optionField.value"
    [label]="_text.search_label"
    [list]="options$$()"
    [optionTemplate]="candidateOption"
    [placeholder]="_text.search_placeholder"
/>
<ng-template #candidateOption let-option>
    <span class="option__name">{{ option.label }}</span>
    @if (!option.isProjectMember) {
        <span class="option__outsider">{{ _text.outsider_suffix }}</span>
    }
    @if (option.email && option.email !== option.label) {
        <span class="option__email">{{ option.email }}</span>
    }
</ng-template>

<app-textarea-control
    [control]="control_body"
    [label]="_text.body_label"
    [maxRows]="8"
    [minRows]="3"
    [required]="true"
/>

<!-- Zelfde action-knoppen als de footer (icoon + tooltip), zoals de betrokkenen-dialoog. -->
<app-buttons-row [align]="buttonsRowAlign.end">
    <app-button-action (btnClick)="emit_cancel()" [tooltip]="_text.cancel">
        <app-icon name="xmark" />
    </app-button-action>
    <app-button-action (btnClick)="emit_confirm()" [disabled]="!canConfirm$$()" [tooltip]="_text.confirm">
        <app-icon name="send-plane" />
    </app-button-action>
</app-buttons-row>
